export default class Project {
    constructor(title, type, description, skills, buttons, images) {
        this.title = title;
        this.type = type;
        this.description = description;
        this.skills = skills;
        this.buttons = buttons;
        this.images = images;
    }
}